// Feature flags — flip to true when ready to launch
export const GOLF_PARTNERSHIP_LIVE = false;
